var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-pay"},[_c('div',{staticClass:"title_header"},[_vm._v("Number of equipment enabled this year: "+_vm._s(_vm.currentEquipYearNum)+" , Growth rate : "+_vm._s(_vm.quipRate))]),_c('div',{attrs:{"id":"index-pay-box-charts"}},[_c('div',{style:({width: '100%', height: '100%'}),attrs:{"id":"myChartWorld"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }